var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFishTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "75mm",
    height: "75mm",
    viewBox: "0 0 212.6 212.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_830484",
    "data-name": 830484
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.69,168.59a3.06,3.06,0,0,1-.94-.14l-2.45-.73A3.3,3.3,0,0,1,56,164.93l-3.44-31.21L29,113.81a3.28,3.28,0,0,1,2.88-5.7l30.59,7.21a3.31,3.31,0,0,1,2,1.46c1.09,1.76,2.19,3.6,3.31,5.46,2.45,4.07,5,8.28,7.41,11.67a3.32,3.32,0,0,1,.41,3.05L64.77,166.45A3.28,3.28,0,0,1,61.69,168.59Zm-18-51,14.08,11.93a3.28,3.28,0,0,1,1.15,2.14l2.68,24.39,7.31-19.79c-2.25-3.29-4.5-7-6.69-10.69-.86-1.42-1.71-2.84-2.55-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.85,115.34a3.25,3.25,0,0,1-1.74-.5c-7.82-4.91-17.3-15.7-21.12-24.07-4.1-8.44-6.58-20.74-6-29.82a5.05,5.05,0,0,1,2-4,3.42,3.42,0,0,1,1.92-.6l8.61.1.28,0a145.76,145.76,0,0,1,31.88,6.82l0,0a9.36,9.36,0,0,1,5.78,11.8,165.26,165.26,0,0,1-13.84,31.26l-.06.09-.43.71a56.43,56.43,0,0,1-4.85,7A3.28,3.28,0,0,1,160.85,115.34ZM138.49,63a60.6,60.6,0,0,0,5.44,25c2.95,6.47,9.95,14.8,16.22,19.59.84-1.23,1.68-2.58,2.45-3.83l.41-.67a158.54,158.54,0,0,0,13.26-30,2.78,2.78,0,0,0-1.61-3.55l1-3.12-1,3.11A139.18,139.18,0,0,0,144.3,63Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.68,141.92a92,92,0,0,1-24.09-3.24,3.26,3.26,0,0,1-1.93-1.42L58.82,120a3.27,3.27,0,0,1-.3-2.84A116.56,116.56,0,0,1,76.26,86.49C92.47,66.34,113,55.91,135.5,56.25a3.28,3.28,0,0,1,3.21,3.66,50.88,50.88,0,0,0,24.09,49.34,3.31,3.31,0,0,1,1.55,2.4,3.25,3.25,0,0,1-.91,2.7c-.39.4-9.76,9.87-25.76,17.65A96.44,96.44,0,0,1,95.68,141.92Zm-21.15-9.24c40.71,10.38,71.78-12.17,81.24-20.21a57.5,57.5,0,0,1-23.89-49.62c-42.76,1.66-63.08,46.34-66.62,55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.39,79.31a5.6,5.6,0,0,1-3.74-3.47h0a5.05,5.05,0,1,1,3.74,3.47Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishTag);
export default __webpack_public_path__ + "static/media/FishTag.ec7fd5d2bada4ac4f00178f62949d703.svg";
export { ForwardRef as ReactComponent };